import { Instagram, Mail, Phone, ArrowUpRight } from "lucide-react";
import { contact, whatsappUrl } from "@/data/brand";
import { track } from "@/services/metrics";

export const SiteFooter = ({ onQuote }) => (
  <footer className="site-footer" data-testid="site-footer">
    <div>
      <p className="eyebrow" data-testid="footer-eyebrow">Build the next rush</p>
      <h2 data-testid="footer-heading">LET'S CREATE<br /><span>SOMETHING THRILLING.</span></h2>
    </div>
    <div className="footer-actions">
      <button className="button button-primary" onClick={() => onQuote("General")} data-testid="footer-request-quote-button">
        Start a project <ArrowUpRight size={18} />
      </button>
      <a href={whatsappUrl("Hi MADMINUTE, let's create something thrilling together.")} target="_blank" rel="noreferrer" className="button button-outline" onClick={() => track("whatsapp_click")} data-testid="footer-whatsapp-button">WhatsApp us</a>
    </div>
    <div className="footer-bottom">
      <div className="brand-mark" data-testid="footer-brand"><img src="/media/brand/madminute-mark-white.png" alt="MADMINUTE official logo" className="official-brand-logo footer-brand-logo" data-testid="footer-official-logo"/><span>MADMINUTE</span></div>
      <div className="footer-contact">
        <a href={`tel:${contact.phoneHref}`} data-testid="footer-phone-link"><Phone size={15} /> {contact.phone}</a>
        <a href={`mailto:${contact.email}`} data-testid="footer-email-link"><Mail size={15} /> {contact.email}</a>
        <a href={`https://instagram.com/${contact.instagram}`} target="_blank" rel="noreferrer" data-testid="footer-instagram-link"><Instagram size={15} /> @{contact.instagram}</a>
      </div>
      <p data-testid="footer-copyright">© {new Date().getFullYear()} MADMINUTE. Fuel your adrenalin rush.</p>
    </div>
  </footer>
);
